/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ZERO_FULL_PAYMENT_REPORT } from "../graphql/getZeroFullPaymentReport.query";
import { VApplication } from "../../../application";
import { pretty } from "@vlinder-web/utils-react";
import { GET_PRESENTATIONS } from "../graphql/getPresentations.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetZeroPaymentReportMethods extends IPluginMethodMap {
  getZeroPaymentReport(args: any): Promise<any>;
}

export class GetZeroPaymentReportService implements IAgentPlugin {
  readonly methods: IGetZeroPaymentReportMethods;

  constructor() {
    this.methods = {
      getZeroPaymentReport: this.getZeroPaymentReport.bind(this),
    };
  }

  async getZeroPaymentReport(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log("args in zero payment service====", pretty(args));
    let filer_apply = args ? args : {};
    console.log("zerofilter apply====", args);
    filer_apply = this.convertCriteria(args);
    let presentationOptions: any = [],
      defaultPresentation: any = "";
    let variables = {
      filter: {
        paymentStats: {
          eq: "UnPaid",
        },
        ...filer_apply,
      },
    };
    const _filter = {
      status: {
        eq: "active",
      },
    };
    console.log("filter in zero payment user", variables);
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
          },
          fetchPolicy: "network-only",
        });
        if (
          presentation &&
          presentation?.data?.getPresentations?.content[0]?.id
        ) {
          defaultPresentation =
            presentation?.data?.getPresentations?.content[0]?.id;
          presentationOptions =
            presentation?.data?.getPresentations?.content?.map((_item: any) => {
              return { value: _item?.id, label: _item?.name };
            });
          variables.filter.presentation = {
            eq: args?.presentation ?? defaultPresentation,
          };
        }
        const res = await client.query({
          query: GET_ZERO_FULL_PAYMENT_REPORT,
          variables: variables,
          fetchPolicy: "network-only",
        });
        return res;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (key != "presentation") result[key] = { contains: criteria[key] };
    }
    return result;
  }
}
